<template>
  <div
    class="ah-filter-group-badge"
    :class="{ active: activeCount > 0 }"
    @click="handleClick"
  >
    <div class="ah-filter-group-badge-label">
      {{ label }}
    </div>

    <div
      v-if="activeCount > 0"
      class="ah-filter-group-children-counter"
    >
      {{ activeCount }}
    </div>
    <div
      v-else
      class="ah-filter-group-plus-icon-container"
    >
      <img
        class="ah-filter-group-plus-icon"
        :src="plusIconSrc"
        aria-hidden="true"
      />
    </div>

  </div>
</template>

<script>
  //import PlusIcon from '../../../../../Static/icons/AH/plus-circle.svg'

  import { mutations } from '../../data/store'

  export default {
    name: 'filter-group-badge',
    props: {
      label: String,
      filters: Array,
    },
    data() {
      return {
        plusIconSrc: '../../../../../Static/icons/AH/plus-circle.svg',
      }
    },
    computed: {
      activeCount: function() {
        return this.filters.reduce((acc, current) => {
          if (current.active) acc += 1
          return acc
        }, 0)
      },
    },
    methods: {
      handleClick: function() {
        mutations.toggleFilterDrawer()
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import "../../../scss/_variablesAH.scss";

  .ah-filter-group-badge {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f6f6f8;
    margin: 4px;
    padding: 12px 15px;
    border-radius: 22px;
    cursor: pointer;
    &:hover {
      background-color: darken(#f6f6f8, 5%);
    }
    &.active {
      background-color: $ah-blue;
      .ah-filter-group-badge-label {
        color: white;
      }
      &:hover {
        background-color: lighten($ah-blue, 5%);
      }
    }
  }
  .ah-filter-group-badge-label {
    font-family: $font-main;
    font-size: 16px;
    color: $ah-blue;
    line-height: 20px;
    font-weight: normal;
    cursor: pointer;
  }
  .ah-filter-group-children-counter {
    background-color: $ah-orange;
    color: $ah-blue;
    font-family: $font-main;
    font-size: 12px;
    line-height: 14px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .ah-filter-group-children-counter, .ah-filter-group-plus-icon {
    margin-left: 8px;
    width: 16px;
    height: 16px;
  }
  .ah-filter-group-plus-icon-container {
    display: flex;
  }
</style>